<template>
  <div class="apply-shop-page">
    <header class="apply-header">
      <button
        class="back-btn"
        type="button"
        :aria-label="$t('utils.cancel')"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shopApply.title') }}</h1>
    </header>

    <main class="apply-body">
      <p class="apply-tip">
        {{ $t('shopApply.tip') }}
      </p>
      <section class="apply-card">
        <label class="form-row">
          <span class="row-label"><van-icon name="shop-o" />{{ $t('shopApply.storeName') }}</span>
          <input
            v-model.trim="form.name"
            type="text"
            :placeholder="$t('shopApply.storeName')"
          >
        </label>
        <label class="form-row">
          <span class="row-label"><van-icon name="phone-o" />{{ $t('shopApply.phone') }}</span>
          <input
            v-model.trim="form.phone"
            type="tel"
            :placeholder="$t('shopApply.phone')"
          >
        </label>
        <!--        <label class="form-row">
          <span class="row-label"><van-icon name="flower-o" />{{ $t('shopApply.line') }}</span>
          <input
            v-model.trim="form.line"
            type="text"
            :placeholder="$t('shopApply.line')"
          >
        </label> -->
        <label class="form-row">
          <span class="row-label"><van-icon name="manager-o" />{{ $t('shopApply.name') }}</span>
          <input
            v-model.trim="form.realname"
            type="text"
            :placeholder="$t('shopApply.name')"
          >
        </label>
        <button
          class="form-row picker-row"
          type="button"
          @click="showPicker = true"
        >
          <span class="row-label"><van-icon name="points" />{{ $t('shopApply.storeType') }}</span>
          <span :class="selectedClassName ? 'picker-value' : 'picker-placeholder'">
            {{ selectedClassName || $t('shopApply.storeTypePlaceholder') }}
          </span>
        </button>
      </section>

      <button
        class="apply-btn"
        type="button"
        :disabled="submitting"
        @click="submitApply"
      >
        {{ $t('shopApply.apply') }}
      </button>
    </main>

    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :title="$t('shopApply.storeType')"
        :columns="pickerColumns"
        :cancel-button-text="$t('utils.cancel')"
        :confirm-button-text="$t('utils.confirm')"
        @cancel="showPicker = false"
        @confirm="onPickerConfirm"
      />
    </van-popup>

    <!--    <div
      v-if="app && app.kefu_link"
      class="kefu"
      @click.stop="kefuTo"
    >
      <div class="kefu_img">
        <van-icon name="service-o" />
      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon, Picker, Popup, Toast } from 'vant';

Vue.use(Icon).use(Picker).use(Popup).use(Toast);

export default {
  name: 'Aplyshop',
  data() {
    return {
      app: {},
      form: {
        name: '',
        phone: '',
        line: '',
        realname: '',
        class: '',
      },
      cates: [],
      showPicker: false,
      submitting: false,
    };
  },
  computed: {
    pickerColumns() {
      return this.cates.map((item) => item.title || '');
    },
    selectedClassName() {
      var current = this.cates.find((item) => Number(item.id) === Number(this.form.class));
      return current ? current.title : '';
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('', true);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      Fetch('/user/shop_info').then((r) => {
        var data = r.data || {};
        var user = data.user || {};
        var shop = data.shop || {};
        this.cates = Array.isArray(data.cates) ? data.cates : [];
        this.form.name = shop.name|| '';
        this.form.phone = shop.phone || user.phone || '';
        this.form.line = shop.line || '';
        this.form.realname = shop.realname  || '';
        this.form.class = shop.class || '';
      });
    },
    onPickerConfirm(value, index) {
      var cate = this.cates[index];
      if (cate) {
        this.form.class = cate.id;
      }
      this.showPicker = false;
    },
    submitApply() {
      if (this.submitting) {
        return;
      }
      if (!this.form.name || !this.form.phone || !this.form.realname || !this.form.class) {
        Toast(this.$t('shopApply.required'));
        return;
      }
      this.submitting = true;
      Fetch('/user/shop_apply', this.form, null, true)
        .then((r) => {
          Toast(this.messageText(r.info) || this.$t('shopApply.success'));
          this.$router.replace('/user');
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    messageText(info) {
      if (!info) return '';
      if (typeof info === 'string') return info;
      var lang = this.$i18n.locale || 'en_us';
      return info[lang] || info.en_us || info.zh_cn || '';
    },
    kefuTo() {
      if (this.app && this.app.kefu_link) {
        window.location.href = this.app.kefu_link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.apply-shop-page {
  min-height: 100vh;
  padding-bottom: 72px;
  background: #f4f4f4;
  color: #07152b;
}

.apply-header {
  position: sticky;
  top: 0;
  z-index: 8;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fb;
}

.apply-header h1 {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
}

.back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  transform: translateY(-50%);
  background: transparent;
  color: #07152b;
}

.back-btn .van-icon {
  font-size: 22px;
}

.apply-body {
  padding: 44px 12px 0;
}

.apply-tip {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 20px;
  color: #999fa9;
}

.apply-card {
  background: #fff;
}

.form-row {
  min-height: 72px;
  display: grid;
  grid-template-columns: 156px minmax(0, 1fr);
  align-items: center;
  border: 0;
  border-bottom: 1px solid #f4f4f4;
  background: #fff;
  padding: 0;
  text-align: left;
  color: #07152b;
}

.row-label {
  display: flex;
  align-items: center;
  min-width: 0;
  padding-left: 4px;
  font-size: 14px;
  line-height: 20px;
}

.row-label .van-icon {
  flex: 0 0 auto;
  margin-right: 6px;
  color: #07152b;
  font-size: 20px;
}

.form-row input,
.picker-value,
.picker-placeholder {
  min-width: 0;
  width: 100%;
  padding: 0 8px;
  border: 0;
  outline: 0;
  background: transparent;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 22px;
  color: #07152b;
}

.form-row input::placeholder,
.picker-placeholder {
  color: #c0c5cf;
}

.apply-btn {
  display: block;
  width: 280px;
  height: 60px;
  margin: 28px auto 0;
  border: 0;
  border-radius: 30px;
  background: #ff1010;
  color: #fff;
  font-size: 14px;
  line-height: 60px;
  font-weight: 700;
}

.apply-btn:disabled {
  opacity: .7;
}

.kefu {
  position: fixed;
  right: 26px;
  bottom: 100px;
  z-index: 12;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
  background: linear-gradient(180deg, #1884ff 0%, #1884ff 68%, #f70720 68%, #f70720 100%);
  box-shadow: 0 4px 14px rgba(0, 0, 0, .22);
  box-sizing: border-box;
}

.kefu_img {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 36px;
}
</style>
